/** Max length of the floor plan editing product comment (unit to draw or notes for the entire plan); mirrors the backend `FloorPlanDTO.ProductConfig.DRAW_ONLY_SPECIFIC_UNIT_COMMENT_MAX_LENGTH` */
export const FLOOR_PLAN_PRODUCT_COMMENT_MAX_LENGTH = 2000
